import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=456d3bc2&scoped=true&"
import script from "./page-header.vue?vue&type=script&lang=ts&"
export * from "./page-header.vue?vue&type=script&lang=ts&"
import style0 from "./page-header.vue?vue&type=style&index=0&id=456d3bc2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456d3bc2",
  null
  
)

export default component.exports